import React, {Component} from 'react'
import { connect } from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import css from './index.css'
import Input from '../MyAccount/share/Input';
import RatioComp from '~/components/common/Ratio';
import { getOrderId , getHpPlanInfo} from '~/modules/membership/actions'
import {getFetchedJSON} from '~/misc/fetch';
import {regEmail, regPhone, regPassWord, regDot, regMc} from '~/misc/reg';
import accounting from '~/misc/accounting';
import {
  replace as replaceURL,
  push as changeURL
} from 'react-router-redux';
import ToolTip from '~/components/common/ToolTip'
import cs from 'classnames'
import { getUrlQeury } from '~/misc/formatUrlquery';
import { track } from '~/misc/metrics';
const Header = () => (
  <div className={css.header}>
    <div className={css.headerWarp}>
      <a href="https://truckerpath.com/truckloads/free-load-board/">
        <div className={css.logo}></div>
      </a>
    </div>
  </div>
)

const Title = () => (
  <div className={css.titleWarp}>
    <div className={css.titleContent}>Get Truckloads Membership</div>
  </div>
) 

const priceFormat = (price) =>  accounting.formatMoney(price/100, "$", 2)

const memberFeatureList = [
  {
    title:"Unlimited Load Views",
    content:"Remove the 5 daily load view limitation and get unlimited access to all loads."
  },
  {
    title:"Days to Pay & Credit Score",
    content:"Greater trust and transparency with your broker or shipper."
  },
  {
    title:"Live Load Updates",
    content:"See new load postings in real-time and be the first to move that load."
  },
  {
    title:"Ad Free",
    content:"Enjoy an ad free experience."
  },
  {
    title:"Driving Time",
    content:"Know your driving time for the trip of loads you are interested in."
  },
  {
    title:"30 Day Rate Check",
    content:"Find out the market price/mile for the lanes you're hauling. Improve your negotiation position."
  },
  {
    title:"Driving Time",
    content:"Know your driving time for the trip of loads you are interested in."
  },
  {
    title:"Fuel Surcharge Calculator",
    content:"Calculate your costs associated with each load, know your actual profit."
  },
  {
    title:"Live Loads Alert",
    content:"Get real-time alerts for loads that match your requirements."
  },
  {
    title:"Bid Visibility",
    content:"See view count and bid prices from other carriers."
  },
  {
    title:"Round Trip",
    content:"View outbound and return loads in a single page."
  },
  {
    title:"Capacity Ratio",
    content:"See the actual inbound and outbound load volume per state, so you know where capacity is tight and where you can make more money."
  },
  {
    title:"1,7,15 Day Rate check",
    content:"Get even more accurate price/mile data on your lanes, down to a 1-7-15 day window."
  },
  {
    title:"Historical Trend",
    content:"Check the past trend for lanes you are interested."
  },
  {
    title:"Capacity Indicator",
    content:"Show the market power of your origin and  destination cities."
  },
]

const text = {
  empty : 'You can\'t leave this empty.',
  dot: {
    wrong: 'Not a valid DOT!',
    invaild: 'Not a valid DOT!',
  },
  termOfService: {
    empty: 'Please read and accept our terms.',
  },
  stripeTerm: {
    empty: 'Please read and accept our terms.',
  },
  email: {
    wrong: 'Enter a valid email!'
  },
  phone: {
    wrong: 'Enter a valid phone number!'
  },
  firstName: {
    wrong: '20 char limit'
  },
  lastName: {
    wrong: '20 char limit'
  },
}

const memberTierMap = {
  "Essnetial" : 4,
  "Preferred" : 8,
  "Ultimate" : 14,
}
const MemberFeature = ({tier}) => {
  const count = memberTierMap[tier] || memberTierMap["Essnetial"];
  return (
    <div className={css.memberFeatureListWarp}>
      {memberFeatureList.filter((el, index)=> index < count).map((feature)=>{
        return (
          <div className={css.memberFeatureItem}>
            <div className={css.memberFeatureTitle}>
              {feature.title}
            </div>
            <div className={css.memberFeatureContent}>
              {feature.content}
            </div>
          </div>
        )
      })}
    </div>
  )
}

const membershipLevel = {
  ESSENTIAL: 'standard',
  PREFERRED: 'premium',
  ULTIMATE: 'professional',
}

const MemberCard = ({ name, price, totalPrice, time, save , freeTime, selected , onClick}) => {
  return (
    <div 
      className={cs(css.memberCardWarp, {
        [css.memberCardWarpSelect] : selected
      })}
      onClick  = {onClick}
    >
      <div className={css.memberCardName}>{name}</div>
      <div className={css.memberCardPrice}>
        <span className={css.memberCardPriceNumber}>{price}</span> /month
      </div>
      <div className={css.memberCardLoop}> 
        {totalPrice && <span className={css.memberCardTotalPrice}>{totalPrice}</span>} Billed {time}
      </div>
      {
        (freeTime  || save)  ? 
        <div className={css.memberBaged}>
          {freeTime ? `${freeTime} months free` : ( save ? `Save ${save}` : '')}
        </div> : null
      }
      {
        selected &&
        <div className={css.memberCardSelectIcon}>
          <div className={css.checkIcon}></div>
        </div>
      }
    </div>
  )
}

const convertMembership = (data, type) => {
  const monthMember = data.find(d => d.show_name.includes("Monthly"))
  const quarterMember = data.find(d => d.show_name.includes("Quarterly"));
  const annualMember = data.find(d => d.show_name.includes("Annually"));
  const memberArray = [];
  memberArray.push({
    type, 
    name :`${monthMember.bill_cycle} Plan`,
    showPrice: monthMember.discount_price,
    price:monthMember.discount_price,
    originPrice: monthMember.origin_price,
    totalPrice: monthMember.discount_price,
    time: monthMember.bill_cycle,
    key: monthMember.key,
    showDescription:  monthMember.show_description,
    showName: monthMember.show_name,
    save: 0,
    freeTime: 0
  })
  if(quarterMember) {
    memberArray.push({
      type, 
      name :`3 Month Plan`,
      showPrice: quarterMember.discount_price / 3,
      price:quarterMember.discount_price,
      originPrice: quarterMember.origin_price,
      totalPrice: quarterMember.discount_price,
      time: 'Quarterly',
      key: quarterMember.key,
      showDescription:  quarterMember.show_description,
      showName: quarterMember.show_name,
      save: monthMember.discount_price - (quarterMember.discount_price+4) / 3,
      freeTime: 0
    })
  }
  if(annualMember) {
    memberArray.push({
      type, 
      name :`Annual Plan`,
      showPrice: type === membershipLevel.ULTIMATE ? (annualMember.discount_price-10) / 12 : (annualMember.discount_price) / 12,
      price:annualMember.discount_price,
      originPrice: annualMember.origin_price,
      totalPrice: annualMember.discount_price,
      time: annualMember.bill_cycle,
      key: annualMember.key,
      showDescription:  annualMember.show_description,
      showName: annualMember.show_name,
      save: 0,
      freeTime: 2
    })
  }
  return memberArray
} 

const CheckBox = ({checked, onClick, children, error}) => {
  return (
    <div>
      <div onClick={(onClick)}  className={css.checkBoxWarp}>
        <div className={cs(css.cleckBoxBox, {
          [css.cleckBoxActive]: checked
        })}>
        </div>  
        <div className={css.cleckBoxContent}>{children}</div>
      </div>
      {
        error && <div className={css.error}>{error}</div>
      }
    </div>
  )
}

const Button = ({onClick, children ,wrapClassName}) => {
  return (
    <div onClick={onClick} className={css.button}>{children}</div>
  )
}

const initLevel = () => Object.values(membershipLevel).reduce((ac,cr)=> {
  ac[cr] = [];
  return ac
}, {})

class Membership extends Component {
  constructor(props){
    super(props);
    const query = getUrlQeury();
    const initType =  query.type || 'Essential';
    const from = query.from
    track("buy_now", {
      membership: initType,
      source: from,
    })
    this.state = { 
      form: {
        termOfService: false,
        stripeTerm: false,
        email: '',
        phone: '',
        firstName: '',
        lastName: '',
        dot: '',
        company: '',
      },
      error: {
        termOfService: '',
        stripeTerm: '',
        email: '',
        phone: '',
        firstName: '',
        lastName: '',
        dot: '',
        company: '',
      },
      membership :  initType,
      card: "",
      membershipInfo:initLevel(),
      paymentError: "",
      source: from,
    }
  }
  getCurrentMemberCardList = () => {
    const { membership, membershipInfo } = this.state;
    return membershipInfo[membershipLevel[membership.toLocaleUpperCase()]]
  }
  getCurrentMemberCard = () => {
    const { card } = this.state;
    if ( !card ) return {}
    const currectCardList = this.getCurrentMemberCardList();
    const currectCard = currectCardList.find(curCard => curCard.key === card);
    return currectCard || {}
  }
  setFirstOrder =() => {
    const currectCard = this.getCurrentMemberCardList() 
    if(currectCard.length) {
      this.changeMembershipCard(currectCard[0].key)
    }
  }

  setMembershipInfo = () => {
    const { getInfo } = this.props;
    Object.values(membershipLevel).map(level => {
      getInfo(level).then(res=> {
        const { data } = res;
        this.setState({
          membershipInfo: {
            ...this.state.membershipInfo,
            [level]: convertMembership( data, level)
          }
        },this.setFirstOrder)
      })
    })
  }

  setFormValue = (key, value) => {
    const form = {
      ...this.state.form,
      [key] :value
    }
    this.setState({
      form
    })
  }
  setError = (key, value) => {
    this.setState({
      error: {
        ...this.state.error,
        [key] :value
      }
    }, ()=> {
      console.log(this.state.error);
    })
  }
  getCardInfo = () => {
    const {membershipInfo, card} = this.state;
    const allCard = Object.values(membershipInfo).flat();
    const currectCard = allCard.find((curCard)=>card === curCard.key)
    return {
      cycle: currectCard.time,
      originPrice: currectCard.originPrice,
      price: currectCard.price,
      showName: currectCard.showName,
      description: currectCard.showDescription,
      key: currectCard.key,
    }
  }
  orderReqBuilder = () => {
    const { form } = this.state;
    return {
      ...this.getCardInfo(),
      ...form,
    }
  }

  componentDidMount () { 
    this.setMembershipInfo();
  }
  checkField = (key) => {
    const { form } = this.state;
    const value = form[key]
    switch(key){
      case 'email': {
        if(!regEmail.test(value)){
          return text.email.wrong;
        }
        break;
      }
      case 'phone': {
        if(!regPhone.test(value)){
          return text.phone.wrong;
        }
        break;
      }
      case 'firstName':
      case 'lastName': {
        if(value.length > 20){
          return  text.firstName.wrong;
        }
        break;
      }
      case 'dot': {
        if(!regDot.test(value)){
          return  text.dot.wrong;
        }
        break;
      }
    }
  }
  checkFieldEmpty = (key) => {
    const { form } = this.state;
    if(form[key] == false) { 
      return (text[key] && text[key].empty) ||text.empty; 
    } 
  }
  checkSingleField = (key) => { 
    let error = { 
      ...this.state.error
    }
    error[key] = this.checkFieldEmpty(key) || this.checkField(key);
    this.setState({
      error
    })
  }
  checkAllField = () => {
    const { form } = this.state;
    let error = {}
    //special check
    Object.keys(form).map(key=> {
      error[key] = this.checkField(key);
    })
    // empty value check 
    Object.keys(form).map(key=> {
      if(form[key] == false) { 
        error[key] = this.checkFieldEmpty(key);
      } 
    })
    this.setState({
      error
    })
    if(Object.values(error).some(e=> e)) return false;
  }

  handleChange(key, value) {
    this.setFormValue(key, value)
  }

  handleBlur (key , value) {
    if(key === 'dot' && value.length) { 
      this.setFormValue('company', '')
      window.fetch(`https://api.truckerpath.com/services/saferwatch/dot/${value}`, {
        method: 'GET',
      })
      .then(getFetchedJSON)
      .then(res => {
        this.setFormValue('company', res.identity.legalName)
        this.setError('dot', '')
      }).catch(e=> {
        this.setError('dot', text.dot.invaild)
      })
    }
    this.checkSingleField(key);

  }

  changeMembership = (memberShip) => {
    this.setState({
      membership: memberShip
    }, this.setFirstOrder)
  }
  changeMembershipCard = (type) => {
    this.setState({
      card: type
    })
  }

  handleSubmit = ()=> {
    const { getOrderId,goToPayment } = this.props  
    const {source} = this.state;
    const error = this.checkAllField();
    if(error) return;
    const reqData = this.orderReqBuilder()
    this.setState({
      paymentError: ""
    })
    getOrderId(reqData).then(res=> {
      goToPayment({
        orderId: res.orderId,
        from: source,
        userId: res.userId,
        token: res.token,
      })
    }).catch(e=> {
      this.setState({
        paymentError: "Error, try again."
      })
    })
    
  }
  render() {
    const { form, error, membership, card ,paymentError} = this.state;
    const memberCardList = this.getCurrentMemberCardList();
    const currectCard = this.getCurrentMemberCard();
    return (
      <div className={css.pageWarp}>
        <Header/>
        <div className={css.hiddenHead}></div>
        <Title/>
        <div className={css.orderWarp}>
          <div className={css.orderFormWarp}>
            <div className={css.orderTitle}>
              Create or use your Truckloads Account 
              <div className={css.hintWarp}>
                <ToolTip
                  trigger={<div className={css.hint}></div>}
                >
                  <div className={css.hintContent}>
                    Please use this email to log in Truckloads to enjoy the ultimate, we will create an account and send the initial password by using this email if you don't have an account with us.
                  </div>
                </ToolTip>
              </div>
              
            </div>
            <form className={css.orderForm}>
              <Input
                label={'email'}
                type='text'
                placeholder="Email(Login)"
                fnChange={(e) => this.handleChange('email', e.target.value)}
                fnBlur={(e) => this.handleBlur('email', e.target.value)}
                error={error.email ? error.email : ''}
              />
              <Input
                label={'phone'}
                type='text'
                placeholder="Phone"
                fnChange={(e) => this.handleChange('phone', e.target.value)}
                fnBlur={(e) => this.handleBlur('phone', e.target.value)}
                error={error.phone ? error.phone : ''}
              />
              <Input
                label={'firstName'}
                type='text'
                placeholder="First Name"
                fnChange={(e) => this.handleChange('firstName', e.target.value)}
                fnBlur={(e) => this.handleBlur('firstName', e.target.value)}
                error={error.firstName ? error.firstName : ''}
              />
              <Input
                label={'lastName'}
                type='text'
                placeholder="Last Name"
                fnChange={(e) => this.handleChange('lastName', e.target.value)}
                fnBlur={(e) => this.handleBlur('lastName', e.target.value)}
                error={error.lastName ? error.lastName : ''}
              />
              <Input
                label={'dot'}
                type='text'
                placeholder="DOT"
                fnChange={(e) => this.handleChange('dot', e.target.value)}
                fnBlur={(e) => this.handleBlur('dot', e.target.value)}
                error={error.dot ? error.dot : ''}
              />
              <Input
                label={'company'}
                type='text'
                placeholder="Company"
                fnChange={(e) => this.handleChange('company', e.target.value)}
                fnBlur={(e) => this.handleBlur('company', e.target.value)}
                defaultValue={form.company}
                error={error.company ? error.company : ''}
                readonly
              />
            </form>
          </div>
          <div className={css.orderMemeberWarp}>
            <div className={css.orderTitle}>
              Unlock Powerful Features
            </div>
            <RatioComp
              wrapClassName = {css.ratioWrap}
              defaultValue = {membership}
              onChange={this.changeMembership}
            >
              <div className={cs(css.ratioItem, css.essential)} label={"Essential"}>
                <span className={css.ratioItemName}>Essential</span>
                <span className={css.ratioItemFeature}>4 Features</span>
              </div>
              <div className={cs(css.ratioItem, css.preferred)} label={"Preferred"}>
                <span className={css.ratioItemName}>Preferred</span>
                <span className={css.ratioItemFeature}>7 Features</span>
              </div>
              <div className={cs(css.ratioItem, css.ultimate)} label={"Ultimate"}>
                <span className={css.ratioItemName}>Ultimate</span>
                <span className={css.ratioItemFeature}>13 Features</span>
              </div>
            </RatioComp>
            <div className={cs(css.memberInfoWarp, {
              [css.memberInfoWarpEssential] : membership === "Essential",
              [css.memberInfoWarpPreferred] : membership === "Preferred",
              [css.memberInfoWarpUltimate] : membership === "Ultimate",
            })}>
              <MemberFeature
                tier={membership}
              ></MemberFeature>
              <div className={css.memberOrder}>
                { 
                  memberCardList.map(data=> {
                    return(
                      <MemberCard
                        type = {data.type}
                        name = {data.name}
                        price = {priceFormat(data.showPrice)}
                        totalPrice = {priceFormat(data.totalPrice)} 
                        time = {data.time} 
                        save = {priceFormat(data.save)}
                        freeTime = {data.freeTime}
                        onClick = {() => this.changeMembershipCard(data.key)}
                        selected = {card === data.key}
                      ></MemberCard>
                    )
                  })
                }
                <div className={css.protocolWarp}>
                  <div >
                    Please find our term of service here for your reference: 
                    <a target="_blank" href="https://truckerpath.com/terms-of-service" className={css.blockLink}>Term of Service</a>
                  </div>
                  <div className={css.protocolRow}>
                    Pay with your credit card via Stripe <img src='/assets/Bank_icon.png' className={css.bankIcon}/>
                  </div>
                  <CheckBox
                    checked={form.termOfService}
                    onClick = {()=> {
                      this.setState({
                        ...this.state,
                        form : {
                          ...form,
                          termOfService: !form.termOfService
                        }
                      })
                    }}
                    error = {error.termOfService}
                  > 
                    I have read and accept the <a target="_blank" href="https://truckerpath.com/terms-of-service">Term of Service</a>
                  </CheckBox>
                  <CheckBox
                    checked={form.stripeTerm}
                    onClick = {()=> {
                      this.setState({
                        ...this.state,
                        form : {
                          ...form,
                          stripeTerm: !form.stripeTerm
                        }
                      })
                    }}
                    error = {error.stripeTerm}
                  >
                    I have read and accept <a  target="_blank" href="https://stripe.com/payment-terms/legal">Stripe Payment Terms</a>
                  </CheckBox>
                </div> 
                <div className={css.subscribeBtn }>
                  <Button 
                    onClick={this.handleSubmit}
                  >
                    {`Subscribe ${priceFormat(currectCard.price)}/month` }
                  </Button>
                  <div className={css.error}>{paymentError}</div>
                </div>    
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default connect(({user, routing, account, hp}) => ({user, routing, account, hp}), mapDispatch({
  getInfo: (props, type) => getHpPlanInfo(type),
  getOrderId: (props, formData) => getOrderId(formData),
  goToPayment: (props, {orderId ,userId ,token , from}) => changeURL(`/orderpage?bussiness_code=vip&order_id=${orderId}&userid=${userId}&token=${token}${from ? ('&source='+from) : ''}`)
}))(Membership);


// WEBPACK FOOTER //
// ./src/components/pages/MemberShip/index.js